<template>
  <el-dialog
    v-model="visible"
    :title="null"
    width="400px"
    :close-on-click-modal="true"
    :show-close="true"
    class="dish-detail-dialog"
  >
    <div class="dialog-content">
      <!-- 菜品大图 -->
      <div class="dish-image">
        <DishImage :fileId="props.dish.fileId" :alt="props.dish.name"></DishImage>
      </div>

      <!-- 菜品信息 -->
      <div class="dish-info">
        <!-- 第一行：菜名 + 分类/标签 -->
        <div class="info-row">
          <h2 class="dish-name">{{ props.dish.name }}</h2>
          <div class="category-tag">
            <span class="dish-category">{{ props.dish.categoryName }}</span>
            <el-tag v-if="props.dish.tag" size="small" type="success">
              {{ props.dish.tagName }}
            </el-tag>
          </div>
        </div>

        <!-- 第二行：价格 + 数量控件 -->
        <div class="info-row">
          <div class="price-section">
            <span class="current-price">¥{{ props.dish.currentPrice?.toFixed(1) }}</span>
            <span v-if="props.dish.currentPrice !== props.dish.price" class="original-price">
              ¥{{ props.dish.price.toFixed(1) }}
            </span>
          </div>
          <div class="quantity-control">
            <el-button 
              :disabled="quantity <= 1"
              size="small" 
              @click.stop="quantity--"
              :icon="Minus" 
              circle 
            />
            <span class="quantity">
              {{ quantity }}
            </span>
            <el-button 
              type="primary" 
              size="small" 
              @click.stop="quantity++"
              :icon="Plus" 
              circle 
            />
          </div>
        </div>

        <!-- 第三行：商品描述 -->
        <div class="dish-description">
          {{ props.dish.description || '暂无描述' }}
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="cart-button-container">
        <el-button type="primary" size="large" @click="addToCart" class="full-width-btn">
          加入购物车
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits} from 'vue'
import { Minus, Plus} from '@element-plus/icons-vue'
import DishImage from '@/components/DishImage.vue'

const props = defineProps({
  dish: {},
  modelValue: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'addToCart'])

const visible = ref(props.modelValue)
const quantity = ref(1)

watch(() => props.modelValue, (val) => {
  visible.value = val
})

watch(visible, (val) => {
  emit('update:modelValue', val)
})

const addToCart = () => {
  emit('addToCart', {
    dish : props.dish
    ,quantity : quantity.value
  })
  visible.value = false
}
</script>

<style scoped>
.dish-detail-dialog :deep(.el-dialog) {
  border-radius: 12px;
  overflow: hidden;
  margin: 0 auto;
}
.dish-detail-dialog :deep(.el-dialog__header) {
  display: none;
}
.dish-detail-dialog :deep(.el-dialog__body) {
  padding: 0;
}

.dialog-content {
  display: flex;
  flex-direction: column;
}

.dish-image {
  position: relative;
  width: 100%;
  height: 250px;
  overflow: hidden;
}

.close-btn {
  position: absolute;
  top: 0px;
  left: 12px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  border: none;
  backdrop-filter: blur(2px);
  transition: background-color 0.2s;
  z-index: 10;
}
.close-btn:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

.dish-info {
  padding: 20px;
  flex: 1;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.dish-name {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #333;
}

.category-tag {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dish-category {
  font-size: 14px;
  color: #999;
}

.price-section {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.current-price {
  font-size: 24px;
  font-weight: bold;
  color: #ff6b6b;
}
.original-price {
  font-size: 14px;
  color: #999;
  text-decoration: line-through;
}

.quantity-control {
  display: flex;
  align-items: center;
  gap: 8px;
}
.quantity {
  font-size: 16px;
  font-weight: 500;
  min-width: 36px;
  text-align: center;
}

.dish-description {
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  margin-top: 8px;
}

.cart-button-container {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  background: white;
}

.full-width-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  border-radius: 8px;
}
</style>